import { IUserOnboardingService } from '../../../services/userOnboardingService';
import bindAllMethods from '../../../utils/bindAllMethods';
import { IUserService } from '../../../services/userService';
import ITenantHandlerService from '../../../services/tenantHandler/ITenantHandlerService';
import { AuthenticationDataType, UserInterfaceV1Type } from '@clientos/types';
import TenantObserver, {
  TenantEvents
} from '../../../services/tenantHandler/TenantObserver';
import {
  CreateTenantOptionsType,
  HandledTenant
} from '../../../services/tenantHandler/types';
import SessionObserver, {
  SessionEvents
} from '../../../services/session/SessionObserver';
import { getServices } from '../../../infra/startup';

class UserInterfaceV1 {
  private _userOnboardingService: IUserOnboardingService;
  private _userService: IUserService;
  private _tenantHandlerService: ITenantHandlerService;

  constructor() {
    const services = getServices();
    this._userOnboardingService = services.userOnboardingService;
    this._userService = services.userService;
    this._tenantHandlerService = services.tenantHandlerService;
    bindAllMethods(this);
  }

  public getInterface(): UserInterfaceV1Type {
    return {
      // For internal use only
      _userData: { get: () => this._userService.get() },
      onboarding: {
        createTenant: (options: CreateTenantOptionsType) =>
          this._tenantHandlerService.createTenant(options),
        isUserOnboarded: () => this._userOnboardingService.isUserOnboarded(),
        joinInvitedOrganization: () =>
          this._userOnboardingService.joinInvitedOrganization(),
        onboardUser: () => this._userOnboardingService.onboardUser(),
        shouldRenderOnboardingScreen: () =>
          this._userOnboardingService.shouldRenderOnboardingScreen()
      },
      getUserData: () => this._userService.get(),
      useAuthenticationData: this.useAuthenticationData,
      getResidenceCountry: () => this._userService.getResidenceCountry()
    };
  }

  public useAuthenticationData(React: any): AuthenticationDataType {
    const authenticationData = this._userService.getAuthenticationData();
    const [result, setResult] = React.useState(authenticationData);

    const setTenantData = (_: HandledTenant[]) => {
      const authData = this._userService.getAuthenticationData();
      setResult(authData);
    };

    React.useEffect(() => {
      TenantObserver.subscribe(TenantEvents.SET_TENANT, setTenantData);
      SessionObserver.subscribe(SessionEvents.LOGGEDIN_FINISHED, setTenantData);
      return () => {
        TenantObserver.unsubscribe(TenantEvents.SET_TENANT, setTenantData);
        SessionObserver.unsubscribe(
          SessionEvents.LOGGEDIN_FINISHED,
          setTenantData
        );
      };
    }, [result]);

    return result;
  }
}

export default UserInterfaceV1;
